import { graphql } from 'react-apollo';
import { assignmentReviewScoringRubric } from 'legacy/src/queries';
import { parseNonEmptyJSONObject } from './utils';

const { parse } = JSON;

export const withAssignmentPreviewScoringRubric = graphql(
  assignmentReviewScoringRubric,
  {
    options: ({ params }) => ({
      fetchPolicy: 'network-only',
      variables: {
        inline: true,
        studentId: params.studentId,
        assignmentId: params.assignmentId,
        assignmentIdAsInt: Number.parseInt(params.assignmentId, 10),
        subjectId: params.subjectId,
        config: JSON.stringify({}),
        showCorrectAnswers: true,
        scorerType: 'student',
      },
    }),
    props: ({
      data: {
        assignmentReview,
        assignmentScoringByRubric,
        assessmentGroupByAssignmentInfo,
        assignment: assigmentPerStudent,
        error,
        loading,
      },
    }) => {
      if (error) {
        return {
          error: error.message.replace(/GraphQL error: /g, ''),
        };
      }

      if (loading) {
        return { loading };
      }

      const { responseAnalysis, scoringRubricResponseAnalysis, progress } =
        assigmentPerStudent || {};

      const {
        scoringRubric: { learnositySignedRequest },
      } = assignmentReview;

      const {
        studentSessionReviewSignedRequest,
        rubricCategoryReferencesByQuestion,
      } = assignmentScoringByRubric;

      let isFinalExam = false;
      if (assessmentGroupByAssignmentInfo) {
        const { type } = assessmentGroupByAssignmentInfo;
        isFinalExam = type && type === 'Pre-AP Final Exam';
      }

      return {
        progressPerStudent: progress,
        scoringRubricSignedRequest: parse(learnositySignedRequest),
        assessmentGroupByAssignmentInfo,
        studentSessionReviewSignedRequest: parse(
          studentSessionReviewSignedRequest,
        ),
        categoriesByQuestion: rubricCategoryReferencesByQuestion,
        responseAnalysisSignedRequest: parse(responseAnalysis),
        scoringRubricResponseAnalysisSignedRequest: parseNonEmptyJSONObject(
          scoringRubricResponseAnalysis,
        ),
        scoringRubricResponses: parseNonEmptyJSONObject(
          assigmentPerStudent.scoringRubricResponses,
        ),
        isFinalExam,
      };
    },
  },
);
